import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePerson } from '../../contexts/PersonContext'
import { NewCircleModal } from '../circles/NewCircleModal'
import { NewGroupModal } from '../groups/NewGroupModal'
import { Button } from '../ui/Button'

/** Visible entry points also work when mobile navigation is closed. */
export function CommunityCreationActions() {
  const { role } = usePerson()
  const navigate = useNavigate()
  const [creating, setCreating] = useState<'circle' | 'group' | null>(null)
  if (role !== 'parent') return null
  return <div className="mt-5 flex flex-wrap gap-3">
    <Button variant="outline" onClick={() => setCreating('circle')}>Start a circle</Button>
    <Button variant="outline" onClick={() => setCreating('group')}>Start a group</Button>
    {creating === 'circle' && <NewCircleModal open onClose={() => setCreating(null)} />}
    {creating === 'group' && <NewGroupModal open mode="create" onClose={() => setCreating(null)} onCreated={(group) => navigate(`/groups/${group.id}`)} />}
  </div>
}
